<ng-content></ng-content>
<div class="d-flex justify-content-between align-items-center">
  <ng-container *ngIf="value !== ''">
    <div class="chart separator-with-border" [ngClass]="{'separator-with-border': shouldApplyLineSeparator}"
         *ngIf="isPercentage">
      <div style="--size:{{value}}"></div>
    </div>

    <div class="chart-cover" *ngIf="!isPercentage">
      <div class="chart is-quantity" style="--size:{{value}}">
      </div>
    </div>
    <div class="percentage" *ngIf="showNumber">{{ text }}</div>
  </ng-container>
</div>
